import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { TablaCamionesEnTransitoView } from '../components/TablaCamionesEnTransitoview'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesEnTransitoActions'
import { INTERVALO_ACTUALIZACION } from '../../../../../config/settings'
import UltimaActualizacionData from '../../../../Utils/containers/UltimaActualizacionDatos'
import { setUltimaActualizacionCDMD } from '../../../actions'

function TablaCamionesEnTransito (props) {
  const { actualizarDatosParaMuiTable } = props
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())

  useEffect(() => {
    actualizarDatosParaMuiTable()

    const interval = setInterval(() => {
      actualizarDatosParaMuiTable()
      setUltimaActualizacion(new Date())
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [actualizarDatosParaMuiTable, setUltimaActualizacion])

  return (
    <>
      <TablaCamionesEnTransitoView />
      <UltimaActualizacionData
        actualizar={actualizarDatosParaMuiTable}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
      />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  setUltimaActualizacionCDMD
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCamionesEnTransito)
